"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverItemTitleWrapper = exports.PopoverItemImageWrapper = exports.PopoverItemWrapper = exports.PopoverItems = exports.PopoverBody = exports.ContentWrapper = exports.PopoverHeader = exports.ButtonWrapper = exports.PopoverArrow = exports.PopoverContent = exports.PopoverTimeBar = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
const react_popover_1 = require("@radix-ui/react-popover");
const TIMEBAR_HEIGHT = '3px';
exports.PopoverTimeBar = (0, flora_react_1.styled)('span', {
    width: '100%',
    height: TIMEBAR_HEIGHT,
    position: 'absolute',
    bottom: 0,
    left: 0,
    background: '$disabledDark',
    borderRadius: '0 0 $small $small',
    overflow: 'hidden',
    '& > span': {
        height: '3px',
        display: 'block',
        background: '$success-alt',
    },
});
const slideUpAndFade = (0, flora_react_1.keyframes)({
    '0%': { opacity: 0, transform: 'translateY(2px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' },
});
const slideRightAndFade = (0, flora_react_1.keyframes)({
    '0%': { opacity: 0, transform: 'translateX(-2px)' },
    '100%': { opacity: 1, transform: 'translateX(0)' },
});
const slideDownAndFade = (0, flora_react_1.keyframes)({
    '0%': { opacity: 0, transform: 'translateY(-2px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' },
});
const slideLeftAndFade = (0, flora_react_1.keyframes)({
    '0%': { opacity: 0, transform: 'translateX(2px)' },
    '100%': { opacity: 1, transform: 'translateX(0)' },
});
exports.PopoverContent = (0, flora_react_1.styled)(react_popover_1.Content, {
    zIndex: '$popover',
    width: '180px',
    animationDuration: '400ms',
    animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
    willChange: 'transform, opacity',
    '&[data-state="open"]': {
        '&[data-side="top"]': { animationName: slideDownAndFade },
        '&[data-side="right"]': { animationName: slideLeftAndFade },
        '&[data-side="bottom"]': { animationName: slideUpAndFade },
        '&[data-side="left"]': { animationName: slideRightAndFade },
    },
});
exports.PopoverArrow = (0, flora_react_1.styled)(react_popover_1.Arrow, {
    fill: '$success-standard',
    width: '16px',
    height: '8px',
});
exports.ButtonWrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    maxWidth: 'min-content',
});
exports.PopoverHeader = (0, flora_react_1.styled)(flora_react_1.Flex, {
    borderTopLeftRadius: '$medium',
    borderTopRightRadius: '$medium',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '$2',
    padding: '$2 $4',
    backgroundColor: '$success-standard',
    textTransform: 'unset',
});
exports.ContentWrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    paddingBottom: TIMEBAR_HEIGHT,
    backgroundColor: '$backgroundPrimary',
    borderTopLeftRadius: '$medium',
    borderTopRightRadius: '$medium',
    borderBottomLeftRadius: '$small',
    borderBottomRightRadius: '$small',
    boxShadow: '$upSoft',
    color: '$nonInteractiveAltPredominant',
    position: 'relative',
});
exports.PopoverBody = (0, flora_react_1.styled)(flora_react_1.Box, {
    padding: '$3 $2',
});
exports.PopoverItems = (0, flora_react_1.styled)('ul', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '$3',
});
exports.PopoverItemWrapper = (0, flora_react_1.styled)('li', {
    display: 'flex',
    padding: '0 $2',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '$2',
    cursor: 'pointer',
});
exports.PopoverItemImageWrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    width: '48px',
    height: '48px',
});
exports.PopoverItemTitleWrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    width: '80px',
    textAlign: 'left',
    fontWeight: '$medium',
    color: '$nonInteractivePredominant',
    span: {
        display: '-webkit-box',
        '-webkit-line-clamp': '4',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordWrap: 'break-word',
    },
});
